import {fill, isNull, range} from 'lodash';

export const ALL_ITEMS = 8;

export function getLoadingItems({
  loadingItemComponent,
  total,
  isCSBReport,
}: any = {}) {
  // Should show 8 loading items if total is null because that means that
  // we don't know the total being loaded and need to load them to check.
  // Null doesn't mean empty, 0 does
  const computedTotal = isCSBReport && total === 0 ? ALL_ITEMS : total;
  const totalItems = isNull(computedTotal) ? ALL_ITEMS : computedTotal;
  const end = totalItems >= ALL_ITEMS ? ALL_ITEMS : totalItems;
  return fill(range(end), loadingItemComponent);
}
